import type { ListingRun } from "@nova-ai/shared"
import { cn } from "../../lib/utils"
import { deriveReadinessTiles, formatRunNumber, type ReadinessFilter } from "../../lib/runs-list"
export function RunsReadinessTiles({
  runs,
  selected,
  onChange,
}: {
  runs: readonly ListingRun[] | undefined
  selected: ReadinessFilter | undefined
  onChange: (value: ReadinessFilter | undefined) => void
}) {
  return (
    <div
      data-runs-tiles
      className="mt-4 mb-3 grid grid-cols-2 gap-2 sm:mt-5 sm:mb-4 sm:gap-3 lg:grid-cols-4"
      role="group"
      aria-label="Filter by readiness"
    >
      {deriveReadinessTiles(runs ?? []).map((tile) => (
        <button
          type="button"
          className="grid cursor-pointer gap-0.5 rounded-lg border border-border bg-card p-3 text-left shadow-card transition-[border-color,background] duration-150 ease-[ease] hover:border-[color-mix(in_oklch,var(--color-foreground)_30%,var(--color-border))] aria-pressed:border-foreground aria-pressed:shadow-[inset_0_0_0_1px_var(--color-foreground)] aria-pressed:hover:border-foreground motion-reduce:transition-none sm:px-4 sm:py-3.5 focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2"
          key={tile.key}
          aria-pressed={selected === tile.key}
          onClick={() => onChange(selected === tile.key ? undefined : tile.key)}
        >
          <span className="flex items-center gap-2 text-[12px] text-muted-foreground">
            <span
              className={cn("size-1.5 flex-none rounded-full bg-current", {
                "text-success": tile.tone === "success",
                "text-warning": tile.tone === "warning",
                "text-muted-foreground": tile.tone === "muted",
              })}
            />

            {tile.label}
          </span>

          <span className="block text-[20px] font-semibold tracking-[-0.02em] whitespace-nowrap tabular-nums sm:text-[24px]">
            {runs && tile.value !== null ? formatRunNumber(tile.value) : "—"}
          </span>

          <span className="block text-[12px] text-muted-foreground tabular-nums">
            {runs ? tile.note : "Waiting for runs"}
          </span>
        </button>
      ))}
    </div>
  )
}
